import Dictionary from "./Dictionary";
import Footer from "./Footer";

import "./App.css";

export default function App() {
  return (
    <div className="App">
      <Dictionary />
      <Footer />
    </div>
  );
}
